export const SAMPLE_PLACEHOLDERS = [
  "[First Name]",
  "[Last Name]",
  "[Appointment Date]",
  "[Appointment Time]",
  "[Agent Name]",
  "[Company Name]",
  "[Brand Name]",
  "[Application Status]",
  "[Order Number]",
  "[Support Phone Number]",
  "[Website URL]",
] as const;

export const PLACEHOLDER_PATTERN = /\[[A-Za-z][A-Za-z ]+\]/g;
